import React, { useContext } from "react";
import {
  CustomDetailsList,
  CustomDetailsListHeader,
  Loader,
} from "../../../shared";
import parse from "html-react-parser";
import { Stack, Box, Typography, Chip } from "@mui/material";
import { AppContext } from "../../../store";
import { RACTDetailsImage } from "./RACTDetailsImage";

export const RACTDetails = ({ state }) => {
  const { appState } = useContext(AppContext);

  const discountTypes = (dt) =>
    appState.globalData?.coupons?.discount_type?.find(
      (item) => item.value === dt,
    )?.label;

  const columns = [
    {
      title: "Name",
      accessor: "name",
    },
    {
      title: "Label",
      accessor: "label",
    },
    {
      title: "Coupon Code ",
      accessor: "coupon_code",
    },
    {
      title: "Description",
      accessor: (row) => {
        return row.description !== null ? (
          <div>{parse(row.description)}</div>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Images",
      accessor: (row) => {
        return row.mobile_image || row.desktop_image ? (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
          >
            {row.mobile_image && (
              <RACTDetailsImage
                url={row.mobile_image}
                alt="Mobile Image"
                containerStyle={{
                  width: "200px",
                }}
              />
            )}

            {row.desktop_image && (
              <RACTDetailsImage url={row.desktop_image} alt="Desktop Image" />
            )}
          </Stack>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Discount Type & Amount",
      header: () => {
        return (
          <CustomDetailsListHeader
            title="Action Type"
            headerStyle={{
              borderBottom: "1px solid",
              borderBottomColor: "divider",
            }}
          />
        );
      },
      accessor: (row) => {
        return (
          <Stack direction="row" alignItems="center" gap="2px">
            <Typography fontSize="14px">
              {discountTypes(row.discount_type)} &nbsp; - &nbsp;
              <Box component="span" color="#C07302">
                {row.discount_type === 1
                  ? `$${row.discount_amount}`
                  : `${row.discount_amount}%`}
              </Box>
            </Typography>
          </Stack>
        );
      },
    },
    {
      title: "Rule Type",
      header: ({ hidden }) => (
        <CustomDetailsListHeader
          title="Rules"
          headerStyle={{
            borderBottom: "1px solid",
            borderBottomColor: "divider",
            display: hidden ? "none" : "block",
          }}
        />
      ),
      accessor: (row) => (row.condition_type === 1 ? "AND" : "OR"),
      hidden: (val) => {
        return val.conditions.length === 0;
      },
    },
    {
      title: "Rules",
      accessor: (row) => {
        const rules = row.conditions;
        return (
          <div>
            <>
              <Box>
                {rules?.map((data) => {
                  return (
                    <Chip
                      component="a"
                      href={`/coupon-rules/edit/${data.id}`}
                      sx={{ mr: 1, borderRadius: "8px", cursor: "pointer" }}
                      label={data.name}
                      variant="filled"
                      size="small"
                      clickable
                    />
                  );
                })}
              </Box>
            </>
          </div>
        );
      },
      hidden: (val) => {
        return val.conditions.length === 0;
      },
    },
    {
      title: "Maximum Product Qty",
      accessor: "applicable_max_product_qty",
      hidden: (val) => {
        return !val.conditions.some((v) => v.scope === 3);
      },
    },
  ];

  return state.isLoading ? (
    <Loader />
  ) : (
    <CustomDetailsList columns={columns} data={state.details} title="Details" />
  );
};
